import React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import begamble from '../../assets/images/faricimage/image-rule/begamble.png';
import gamcare from '../../assets/images/faricimage/image-rule/gamcare.png';
import gamstop from '../../assets/images/faricimage/image-rule/gamstop.png';
import './ResponsibleGaming.scss';
import { AboutUsRules, ResponsibleGamingLink, ResponsibleGamingRules, TermsConditionRules } from '../../socialmedialink/ResponsibleGamingRules';
import { IonButtons } from '@ionic/react';

type TermsProps = {
  name?: string;
  eventTypeID: string;
};

const ResponsibleGaming: React.FC<TermsProps> = (props) => {
  const { eventTypeID } = props;
  const socialmedialink = ResponsibleGamingLink;

  const onLink = (linkname: string) => {
    socialmedialink.forEach((element) => {
      if(element.name === linkname && element.link !== ''){
       let urlLink = element.link;
        window.open(urlLink, "_blank")
      }
    })
  };

  return (
    <div className="odds-terms-condi-ctn">
      {eventTypeID === 'Responsible Gaming' ? (
        <>
          {ResponsibleGamingRules.map((r, index) => (
            <Accordion className="rules-accordion">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>{r.category?.toLocaleLowerCase()}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {r.rules.map((r, index) => (
                  <p className="conditions-paragraph">
                    {r}
                  </p>
                  
                ))}
                {r.image === 'true' ? (
                  <>
                    <IonButtons className="social-media-group" >
                      <div>
                        <img className='footer-logo-mob' src={begamble} onClick={() => onLink('begambleaware')}/>
                      </div>
                      <div>
                        <img className='footer-logo-mob' src={gamcare} onClick={() => onLink('gamcare')}/>
                      </div>
                      <div>
                        <img className='footer-logo-mob' src={gamstop} onClick={() => onLink('gamstop')}/>
                      </div>
                      </IonButtons>
                  </>
                ): null}
                
              </AccordionDetails>
            </Accordion>
          ))}
        </>
      ) : null}

      {eventTypeID === 'About Us' ? (
        <>
          {AboutUsRules.map((r, index) => (
            <Accordion className="rules-accordion" expanded>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>{r.category?.toLocaleLowerCase()}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {r.rules.map((r, index) => (
                  <p className="conditions-paragraph">
                    {r}
                  </p>
                  
                ))}
                {r.image === 'true' ? (
                  <>
                    <IonButtons className="social-media-group" >
                      <div>
                        <img className='footer-logo-mob' src={begamble} onClick={() => onLink('begambleaware')}/>
                      </div>
                      <div>
                        <img className='footer-logo-mob' src={gamcare} onClick={() => onLink('gamcare')}/>
                      </div>
                      <div>
                        <img className='footer-logo-mob' src={gamstop} onClick={() => onLink('gamstop')}/>
                      </div>
                      </IonButtons>
                  </>
                ): null}
                
              </AccordionDetails>
            </Accordion>
          ))}
        </>
      ) : null}

{eventTypeID === 'Terms and conditions' ? (
        <>
          {TermsConditionRules.map((r, index) => (
            <Accordion className="rules-accordion" expanded>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>{r.category?.toLocaleLowerCase()}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {r.rules.map((r, index) => (
                  <p className="conditions-paragraph">
                    {r}
                  </p>
                  
                ))}
                
              </AccordionDetails>
            </Accordion>
          ))}
        </>
      ) : null}
    </div>
  );
};

export default ResponsibleGaming;
